import './index.less';
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Input } from '@ss/mtd-react3';
import { useRequest } from 'ahooks';
import { useLocation } from 'react-router-dom';

import { getHotSearchWord } from '@cap/share/src/apis/search';
import useRouteParams from '@cap/share/src/hooks/useRouteParams';

interface ChildProps {
  keywordChange?: (eventData: string, placeholder: string) => void;
  bgNum?: number;
}
interface HotModuleData {
  word: string;
  icon: string;
}

const SearchBar: React.FC<ChildProps> = ({ keywordChange, bgNum = 255 }) => {
  const location = useLocation();
  // 解析查询参数
  const queryParams = new URLSearchParams(location.search);
  const key = queryParams.get('key');
  const [value, setValue] = useState('');
  const { params } = useRouteParams();
  const { tenant } = params;

  const [hotModule, setHotModule] = useState<HotModuleData[]>([]);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const carouselTime = 5000; // 定时器时间

  // 加载热搜词
  const { run: loadHotSearchWords } = useRequest(() => getHotSearchWord<HotModuleData[]>({ tenant }), {
    manual: true,
    onSuccess(res) {
      if (res) {
        setHotModule(res.data.slice(0, 6)); // 限制最多 6 个热搜词
      }
    },
    onError(error) {
      console.error('加载热搜词失败:', error);
    },
  });

  // 轮播定时器控制
  const setTimer = useCallback(() => {
    if (hotModule.length <= 1) return;

    const timer = setInterval(() => {
      setCarouselIndex((prevIndex) => (prevIndex + 1) % hotModule.length);
    }, carouselTime);

    return timer;
  }, [hotModule]);

  // 组件加载时获取热搜词
  useEffect(() => {
    loadHotSearchWords();
  }, [loadHotSearchWords, tenant]);

  useEffect(() => {
    if (key) setValue(key);
  }, [key]);

  // 轮播控制
  useEffect(() => {
    if (hotModule.length > 0) {
      const timer = setTimer();
      return () => clearInterval(timer); // 清理定时器
    }
  }, [hotModule, setTimer]);

  // 计算动态 placeholder
  const placeholder = useMemo(() => {
    const word = hotModule[carouselIndex]?.word;

    if (!word) {
      return '搜索课程';
    }

    if (word.length <= 8) {
      return word;
    }

    return `${word.slice(0, 8)}..`;
  }, [carouselIndex, hotModule]);

  // 处理输入框内容变化
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  // 处理搜索
  const handleSearch = () => {
    if (keywordChange) {
      keywordChange(value, placeholder);
    }
  };

  // 处理回车键
  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="searchBarWap" style={{ backgroundColor: `rgba(${bgNum}, ${bgNum}, ${bgNum})` }}>
      <Input
        type="text"
        value={value}
        placeholder={placeholder}
        onInput={handleInputChange}
        onKeyUp={handleKeyUp}
        clearable={false}
        suffix={
          <img
            className="search-icon"
            src="//img.meituan.net/mtdxweb/b6e4f22b618c855767cea815036a39fc564.png"
            style={{ cursor: 'pointer' }}
            onClick={handleSearch}
            alt="search"
          />
        }
      />
    </div>
  );
};

export default SearchBar;
